import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators, FormArray } from '@angular/forms';
import { SharedService } from '../_service/shared.service';
import { MessagingService } from '../_service/messaging.service';
import { ActivatedRoute, Router  } from '@angular/router';
@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.css']
})
export class MessagesComponent implements OnInit {
  messageForm: FormGroup;submitted = false;loading:boolean=false;leadId:any ='';allmessages = [];userId:string;refreshloading:boolean=true;bdName:any;TreatmentName:any;

  constructor(private sharedapi:SharedService,private messageapi:MessagingService,private formBuilder: FormBuilder,private router:Router,private activatedRoute: ActivatedRoute) {
      this.activatedRoute.params.subscribe(params => {
        if (params['lead_id']) {
            this.leadId = params['lead_id'];
            this.getWhatAppMessagesLeadWise();
        }
      });

    this.messageForm = this.formBuilder.group({ 
     'message' : [null, Validators.required],
     'lead_id' : [this.leadId],
     'type' : [1],
     'selectfileName' : [null],
     'filepath' : [null],
     'template_id' : [null]
    });
   }

  ngOnInit(): void {
    this.userId = localStorage.getItem('loginuserId');
  }
  get f() { return this.messageForm.controls; }

  uploadFile(event){
    console.log(event);
    this.messageForm.controls['type'].setValue(2);
    console.log(this.messageForm.value);
    const file = (event.target as HTMLInputElement).files[0];
    this.messageForm.controls['selectfileName'].setValue(file.name);
    
    console.log(file);
      this.messageForm.patchValue({
        message: file
      });
  }

  sendTemplateMessage(templateId){
    var Message = '';
    if(templateId=='en_dnp_new'){
      Message = 'Greetings from Glamyo Health, I am trying to connect with you regarding your enquiry about '+this.TreatmentName+'. Please let me know a preferable time to connect with you. '+this.bdName+'';
    }else if(templateId=='en_followup_new'){
      Message = 'Greetings from Glamyo Health, The last time we interacted, we discussed your health condition. It would be great if we can reconnect again to understand your requirements better so that we can extend our assistance in your treatment. '+this.bdName+'';
    }else if(templateId=='en_insurancecard_new'){
      Message = 'Greetings from Glamyo Health, We recently connected regarding your '+this.TreatmentName+'. As we discussed, kindly share your insurance card so that we can assist you further. '+this.bdName+' ';
    }else{
      Message = 'Greetings from Glamyo Health, We connected to talk about your treatment requirements. Before further assistance, kindly share your medical reports and prescription, if any. '+this.bdName+' ';
    }
    
    this.messageForm.controls['type'].setValue(3);
    this.messageForm.controls['message'].setValue(Message);
    this.messageForm.controls['template_id'].setValue(templateId);


  }

  clearMessage(){
    this.messageForm.controls['selectfileName'].setValue('');
    this.messageForm.controls['type'].setValue(1);
    this.messageForm.controls['message'].setValue('');

  }

  sendMessage(){
    this.submitted = true;
    this.loading = true;
    // stop here if form is invalid
    if (this.messageForm.invalid) {
        this.loading = false;
        return;
    }
    //console.log(this.messageForm.value);
    //return false;
    if(this.messageForm.controls['type'].value == 1){
      this.messageapi.sendMessage(this.messageForm.value)
      .subscribe((data:any) => {
        this.submitted = false;
        this.loading = false;
        if(data.status)
        {
          this.sharedapi.presentToast(data.msg);
          this.messageForm.controls['message'].setValue('');
          this.getWhatAppMessagesLeadWise();
        }
        else
        {
            this.sharedapi.presentToast(data.msg);
        }
      }, error => 
      {
          this.sharedapi.checkError(error);
      });

    }else if(this.messageForm.controls['type'].value == 2){
      this.messageapi.sendMediaMessage(this.messageForm.value)
      .subscribe((data:any) => {
        this.submitted = false;
        this.loading = false;
        if(data.status)
        {
          this.sharedapi.presentToast(data.msg);
          this.messageForm.controls['selectfileName'].setValue('');
          this.messageForm.controls['type'].setValue(1);
          this.messageForm.controls['message'].setValue('');
          this.getWhatAppMessagesLeadWise();
        }
        else
        {
            this.sharedapi.presentToast(data.msg);
        }
      }, error => 
      {
          this.sharedapi.checkError(error);
      });
    }else{
      this.messageapi.sendTemplateMessage(this.messageForm.value)
      .subscribe((data:any) => {
        this.submitted = false;
        this.loading = false;
        if(data.status)
        {
          this.sharedapi.presentToast(data.msg);
          this.messageForm.controls['selectfileName'].setValue('');
          this.messageForm.controls['type'].setValue(1);
          this.messageForm.controls['message'].setValue('');
          this.getWhatAppMessagesLeadWise();
        }
        else
        {
            this.sharedapi.presentToast(data.msg);
        }
      }, error => 
      {
          this.sharedapi.checkError(error);
      });
    }
    
  }

  getWhatAppMessagesLeadWise()
    {
       this.refreshloading = true;
       this.messageapi.getMessageByLead(this.leadId).subscribe((data:any) => {
            if(data.status)
            {
               this.allmessages = data.data;
               this.bdName = data.bdname;
               this.TreatmentName = data.treatment;
               this.refreshloading = false; 
            }else{
              this.sharedapi.presentToast(data.msg);
              this.router.navigate(['/sheetview']);
            }
        }, error => {
            this.sharedapi.checkError(error);
            this.refreshloading = false; 
        });
        this.removeMessageCount();
    }

    removeMessageCount()
    {
       this.messageapi.removeWhatsappNotification(this.leadId).subscribe((data:any) => {
            if(data.status)
            {
            }
            else{}
        }, error => {
            this.sharedapi.checkError(error);
            this.refreshloading = false; 
        });
    }

}
